import { observer } from 'mobx-react-lite'
import {
  type IDropOptions,
  type IInboxTreeCombine,
  type INodeModel,
  TreeRootInboxes,
} from 'entities/Inbox'
import { MenuSectionTree } from 'pages/conversations/ui/ConversationMenu/ui/ConversationMenuInboxes/MenuSectionTree/MenuSectionTree.tsx'
import { useConversationMenuContext } from 'pages/conversations/ui/ConversationMenu/context'
import { SkeletonMenuSection } from 'pages/conversations/ui/ConversationMenu/ui/ConversationMenuInboxes/SkeletonMenuSection/SkeletonMenuSection.tsx'

type IMenuFavoritesInboxesProps = {
  onDrop: (
    items: INodeModel<IInboxTreeCombine>[],
    options: IDropOptions<IInboxTreeCombine>,
    dropRoot: TreeRootInboxes
  ) => void
  onClickItem: () => void
}

export const MenuFavoritesInboxes = observer(
  ({ onDrop, onClickItem }: IMenuFavoritesInboxesProps) => {
    const store = useConversationMenuContext()
    const { favoritesMenuStore } = store
    const { loading, selectInboxesCount, hideInboxes } = favoritesMenuStore

    const itemsFavoritesCount = selectInboxesCount
    const hideFavoritesInboxes = hideInboxes

    if (loading) {
      return <SkeletonMenuSection items={[40, 56, 64]} withTitle />
    }

    if (hideFavoritesInboxes) return null

    return (
      <MenuSectionTree
        items={favoritesMenuStore.items}
        count={itemsFavoritesCount}
        title='Favorites'
        root={TreeRootInboxes.FAVORITE}
        useSearch={{
          handleSearch: favoritesMenuStore.handleUpdateSearch,
          search: favoritesMenuStore.search,
          placeholder: 'Search favorites',
          autofocus: true,
          variant: 'transparent',
        }}
        handleDrop={onDrop}
        onClickItemTree={onClickItem}
      />
    )
  }
)
